import { render } from "./tezTacToe.vue?vue&type=template&id=231dc751&scoped=true"
import script from "./tezTacToe.vue?vue&type=script&lang=js"
export * from "./tezTacToe.vue?vue&type=script&lang=js"

import "./tezTacToe.vue?vue&type=style&index=0&id=231dc751&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-231dc751"]])

export default __exports__